import React from "react";

import { firebase } from "../firebase";
import ProfileContext from "./ProfileContext";
import { getMyProfile } from "../firebase/firestore";

const profileScope = Component =>
  class ProfileScope extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        profile: null
      };
    }

    componentDidUpdate() {
      if (this.state.profile === null && firebase.auth.currentUser !== null) {
        getMyProfile(
          firebase.auth.currentUser.uid,
          user => {
            this.setState({
              profile: {
                id: user.id,
                ...user.data()
              },
              error: false
            });
          },
          error => {
            this.setState({ profile: null, error: true });
          }
        );
      }
    }

    render() {
      const { profile } = this.state;

      return (
        <ProfileContext.Provider value={profile}>
          <Component />
        </ProfileContext.Provider>
      );
    }
  };

export default profileScope;



// WEBPACK FOOTER //
// ./src/utils/ProfileScope.js